'use strict';

const _ = require('underscore');
const Mn = require('backbone.marionette');
const i18n = require('i18next');
const RelatedKeys = require('common/domain/value/related-keys');
const AuthService = require('system/domain/service/auth');
const NavView = require('balus/ui/view/body/diagram/nav/index');
const ToolbarView = require('balus/ui/view/body/diagram/toolbar/index');
const CanvasView = require('balus/ui/view/body/diagram/content/index');
const TagAction = require('system/domain/action/tag');
const ModeIndicatorView = require('common/ui/view/mode-indicator');
const SnapshotModeIndicatorView = require('system/ui/view/mode-indicator/snapshot');
const SidebarView = require('common/ui/view/sidebar/index');
const SidebarCollection = require('common/ui/view/sidebar/collection');
const CommentCollectionRepository = require('communication/domain/repository/comment-collection');
const TaskCollectionRepository = require('communication/domain/repository/task-collection');
const TaskRelatedListView = require('communication/ui/view/task/related-list');
const EventAction = require('notify/domain/action/event');
const ElementAction = require('system/domain/action/element');
const ElementRepository = require('system/domain/repository/element');
const DiagramRepository = require('system/domain/repository/diagram');
const TagListView = require('system/ui/view/tag/list');
const OwnerListView = require('system/ui/view/owner/list');
const ContentTemplate = require('balus/ui/template/body/diagram/index.hbs');
const CoverView = require('balus/ui/view/body/diagram/cover');
const DescriptionView = require('balus/ui/view/body/diagram/sidebar/description');
const TimelineView = require('balus/ui/view/timeline/index');
const AdditionalView = require('balus/ui/view/additional/index');

module.exports = Mn.View.extend({
    className: 'row',
    template: ContentTemplate,
    regions: {
        nav: '#nav',
        cover: '#cover',
        toolbar: '#toolbar',
        content: '#content',
        sidebar: '#sidebar',
        modeIndicator: '#mode-indicator'
    },

    onRender: function() {
        const context = this.getOption('context');
        const appInfo = context.getAppInfo();
        const user = context.getUser();
        const group = context.getGroup();
        const project = context.getProject();
        const channel = this.getOption('channel');

        const urlParams = new URLSearchParams(location.search);
        const dt = urlParams.get('dt');
        const oldContext = {
            groupId: group.id,
            projectId: this.model.getProjectId(),
            diagramId: this.model.id,
            dt: dt
        };

        this.showChildView('cover', new CoverView({
            model: this.model,
            project: project
        }));

        let mode = 'edit';
        if(dt) {
            mode = 'snapshot';
        }
        const auth = new AuthService({
            mode: mode,
            isMember: group.isMember(user ? user.id : null),
            isAdmin: group.isAdmin(user ? user.id : null)
        });

        if(this.model.isEditLocked()) {
            auth.lock();
        } else {
            auth.unlock();
        }

        if(mode == 'snapshot') {
            auth.unlock();
        }
        this._auth = auth;

        window.onbeforeunload = function(){
            const isUnsaved = function(model) {
                const state = model.syncState;
                return (
                    state.isSyncing() ||
                    state.isUnsync() ||
                    state.isConflict()
                )
            };
            if(
                ElementRepository.getNodes({
                    context: oldContext
                }).any(isUnsaved) ||
                ElementRepository.getLinks({
                    context: oldContext
                }).any(isUnsaved) ||
                DiagramRepository.getNodeMetas({
                    context: oldContext
                }).any(isUnsaved) ||
                DiagramRepository.getLinkMetas({
                    context: oldContext
                }).any(isUnsaved)
            ) {
                return i18n.t('notify.not-save');
            }
        };

        const recordIDs = _.keys(this.model.get('records'));
        const relationIDs = _.keys(this.model.get('relations'));

        // Records の取得が完了した後に Relations の取得を行うこと
        ElementAction.fetchRecordsByPartialOnce({context: oldContext}, recordIDs)
            .then(() => {
                ElementAction.fetchRelationsByPartialOnce({context: oldContext}, relationIDs)
                    .then(() => {
                        const pattern = new RegExp('#/elements/([0-9a-f]+)');
                        const id = location.hash && location.hash.match(pattern) &&
                            location.hash.match(pattern)[1];
                        let models = [];

                        if(id) {
                            models = channel.request('find:elements:idStartsWith', id);
                        }

                        if(models.length === 1) {
                            models[0].select();
                            channel.request('canvas:zoomTo', models[0], 0);
                        } else {
                            channel.request('canvas:showFull', 0);
                        }
                    });
            });

        this.showChildView('nav', new NavView({
            model: project,
            context: context.getParent(), // ProjectContext
            diagram: this.model
        }));

        this.showChildView('toolbar', new ToolbarView({
            model: this.model,
            context: context,
            oldContext: oldContext,
            channel: channel,
            messengerChannel: this.getOption('messengerChannel'),
            auth: auth,
            user: user,
            group: group,
            project: project
        }));
        this.showChildView('content', new CanvasView({
            model: this.model,
            context: context,
            oldContext: oldContext,
            channel: channel,
            auth: auth,
            user: user,
            group: group,
            project: project,
            appInfo: appInfo
        }));

        this.setModeIndicator();
        this.listenTo(auth, 'change:mode', this.setModeIndicator);
        this.listenTo(auth, 'change:lock', this.getChildView('content').setLockState);

        Promise.all([
            CommentCollectionRepository.find(project).byKey(this.model.key).fetchFirstPage(),
            TaskCollectionRepository.find(project).byKey(this.model.key).fetchFirstPage()
        ])
            .then(values => {
                const comments = values[0];
                const tasks = values[1];
                const relatedKeys = new RelatedKeys([this.model.key]);

                const navs = new SidebarCollection(
                    [
                        {
                            name: 'description',
                            icon: 'fa fa-info-circle',
                            label: 'module/word:description',
                            view: new DescriptionView({
                                model: this.model
                            })
                        },
                        {
                            name: 'timeline',
                            icon: 'fa fa-comments-o',
                            label: 'module/word:timeline',
                            header: i18n.t('balus_template_body_diagram:sidebar.timeline-title', {name: this.model.get('name'), interpolation: { escapeValue: false }}),
                            view: new TimelineView({
                                model: this.model,
                                collection: comments,
                                context: context,
                                onCommentActivate: () => {
                                    channel.request('cmd:sidebar:comment:activate');
                                }
                            }),
                            badge: {
                                content: function(){
                                    return comments.getTotalCount();
                                },
                                listen: function(onChange){
                                    comments.on('change:totalCount', onChange);
                                }
                            }
                        },
                        {
                            name: 'task',
                            icon: 'fa fa-check-square',
                            label: 'module/word:task',
                            header: i18n.t('balus_template_body_diagram:sidebar.timeline-title', {name: this.model.get('name'), interpolation: { escapeValue: false }}),
                            view: new TaskRelatedListView({
                                collection: tasks,
                                context: context,
                                AdditionalView: AdditionalView,
                                relatedKeys: relatedKeys
                            }),
                            badge: {
                                content: function(){
                                    return tasks.getTotalCount();
                                },
                                hasUnread: function() {
                                    return tasks.hasUnfinishedTask();
                                },
                                listen: function(onChange){
                                    tasks.on('change:totalCount', onChange);
                                    tasks.on('change:update', onChange);
                                }
                            }
                        },
                        {
                            name: 'members',
                            icon: 'fa fa-user',
                            label: 'module/word:member',
                            view: new OwnerListView({
                                collection: group.getMembers({withSuspended: true}),
                                context: oldContext,
                                channel: channel,
                                diagramContext: oldContext
                            })
                        },
                        {
                            name: 'tags',
                            icon: 'fa fa-tags',
                            label: 'module/word:tag',
                            view: new TagListView({
                                editable: auth.isTagEditable(),
                                context: oldContext,
                                channel: channel,
                                diagramContext: oldContext
                            })
                        }
                    ]
                );

                this.showChildView('sidebar', new SidebarView({
                    model: this.model,
                    navs: navs,
                    horizontalNav: true
                }));
                this.getChildView('toolbar').renderNav(navs);

                const sidebarView = this.getChildView('sidebar');
                channel.reply('print:canvas', function(){
                    sidebarView.close();

                    setTimeout(() => {
                        window.print();
                    }, 300);
                });

                channel.reply('cmd:sidebar:comment:activate', function(){
                    sidebarView.activate('timeline');
                });
                const timelineView = navs.getByName('timeline').getView();

                channel.on('append:comment:records', function(records){
                    sidebarView.activate('timeline');
                    _.each(records, record => {
                        timelineView.addRecord(record);
                    });
                    timelineView.openComment();
                });

                channel.on('append:comment:record', function(record){
                    sidebarView.activate('timeline');
                    timelineView.addRecord(record);
                    timelineView.openComment();
                });

                channel.on('append:comment:relations', function(relations){
                    sidebarView.activate('timeline');
                    _.each(relations, relation => {
                        timelineView.addRecord(relation);
                    });
                    timelineView.openComment();
                });

                const activateComment = () => {
                    const commentTimelineView = this.getChildView('sidebar').getView('timeline');
                    commentTimelineView.activateByHashState();
                };
                activateComment();
                window.addEventListener('hashchange', activateComment, false);
                this.on('destroy', () => {
                    window.removeEventListener('hashchange', activateComment, false);
                });
            });

        TagAction.fetchTagsOnce(this.model.getProjectId());
        EventAction.fetchDiagramEventsOnce(
            this.model.getProjectId(), this.model.id);

        // id が str から始まる element のリストを返す
        const getElementsOfIdStartsWith = function(str) {
            if (str[0] === '#') {
                str = str.slice(1);
            }
            const idStartsWith = function(model) {
                return model.id.indexOf(str) === 0;
            };
            const nodes = ElementRepository.getNodes({
                context: oldContext
            }).filter(idStartsWith);
            const links = ElementRepository.getLinks({
                context: oldContext
            }).filter(idStartsWith);

            return _.flatten([nodes, links]);
        };
        channel.reply('find:elements:idStartsWith', getElementsOfIdStartsWith);

        window.addEventListener('hashchange', () => {
            const pattern = new RegExp('#/elements/([0-9a-f]+)');
            const elementID = location.hash && location.hash.match(pattern) && location.hash.match(pattern)[1];
            if(!elementID) {
                return;
            }

            _.each(getElementsOfIdStartsWith(elementID), e => e.select());
        }, false);

        channel.reply('cmd:save', function(params){
            const j = {
                context: oldContext,
                metas: {nodes: {}, links: {}},
                models: {nodes: [], links: []}
            };
            _.each(params.nodes, function(n) {
                j.models.nodes.push(n.toJSON());
            });
            _.each(params.links, function(l) {
                j.models.links.push(l.toJSON());
            });
            _.each(params.nodeMetas, function(n) {
                const k = {};
                k[n.id] = n.toJSON();
                j.metas.nodes = _.extend(
                    j.metas.nodes, k);
            });
            _.each(params.linkMetas, function(n) {
                const k = {};
                k[n.id] = n.toJSON();
                j.metas.links = _.extend(
                    j.metas.links, k);
            });
            if (params.commitComment) {
                j.commitComment = params.commitComment;
            }

            return ElementAction.saveElements(j);
        });
    },

    setModeIndicator: function() {
        const mode = this._auth.getMode();

        if(mode === 'view') {
            this.showChildView('modeIndicator', new ModeIndicatorView({
                iconClass: 'fa fa-eye',
                title: i18n.t('diagram:editMode.view.name')
            }));

            return;
        }

        if (mode === 'multi' || mode === 'rectSelect') {
            this.showChildView('modeIndicator', new ModeIndicatorView({
                iconClass: 'fa fa-object-group',
                title: i18n.t('diagram:editMode.multi.name')
            }));

            return;
        }

        if(mode === 'snapshot') {
            this.showChildView('modeIndicator', new SnapshotModeIndicatorView({
                dt: this.getOption('context').getDt(),
                url: this.model.path()
            }));

            return;
        }

        this.getRegion('modeIndicator').empty();
    },

    onDestroy: function() {
        const channel = this.getOption('channel');

        channel.off('append:comment:records');
        channel.off('append:comment:record');
        channel.off('append:comment:relations');
    }
});



// WEBPACK FOOTER //
// ./balus/ui/view/body/diagram/index.js